export default __webpack_public_path__ + "static/regular-1d3cfabaf123b01ec3d984b1984efdd6.woff2";